import { inject, Injectable } from '@angular/core';

import { Oauth2Service } from '@bytel/checkout';

import { Observable, of } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';
import { tunnelRoutes } from '~/src/app/tunnel/routes';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class InstallationStep extends Step {
    public static readonly key: string = 'install';
    public label: string = 'Installation';
    public next: Step;
    public routerLink: string = `/tunnel/${tunnelRoutes.install}`;
    public hasReminder = true;
    public icon: string = 'tri-home-tools';
    protected oauth2Service: Oauth2Service = inject(Oauth2Service);
    private cookieService: CookieService = inject(CookieService);
    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(this.canDisplay() && this.oauth2Service.isConnected);
    }

    public canDisplay(): boolean {
        return this.cookieService.get('abtest_install') === 'true';
    }
}
